// testimonials.ts
export const testimonials = [
  {
    quote:
      "Our experience working with iCXeed has been really positive. Together, we’re developing some exciting AI-driven innovations on the AWS platform that are helping us take customer experience to the next level.",
    author: "Stefan Hutton",
    role: "Managing Director",
    company: "Scene to Believe",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/steffan-hutton.png",
  },
  {
    quote:
      "iCXeed has delivered Amazon Connect the way it's meant to be: rapid, iterative and cost-efficient. They're responsive, light on process and big on experimentation. This has generated real trust with the business and enabled me to build a cadence to deliver continuous improvement. That's the true sweet spot for agile.",
    author: "Hamish Stewart",
    role: "Director",
    company: "Flare Design",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/hamish-stewart.png",
  },
  {
    quote:
      "Our experience with iCXeed has been excellent. Their strong partnership with AWS, expertise in Amazon Connect, and customer-centric approach to change management are supporting the University of Melbourne's transition to a modern Contact Centre platform.",
    author: "Abhi Chaubey",
    role: "Senior Project Manager (CCaaS)",
    company: "The University of Melbourne",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/abhi-chaubey.png",
  },
  {
    quote:
      "Working with iCXeed has been a seamless and collaborative experience. Their team has consistently brought clarity and momentum to our AI and CX initiatives, project managing with precision and solving challenges proactively. Their support has been key to accelerating our innovation.",
    author: "Lucy Pickering",
    role: "Service Delivery Manager",
    company: "Sentral",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/lucy-pickering.png",
  },
];
